// Light organization (frontend only): exactly half of the items online, rounded up; really online ones first.
export function lightOnline(items, isOnline, setOnline) {
  const shown = new Set([...items].sort((a, b) => isOnline(b) - isOnline(a)).slice(0, Math.ceil(items.length / 2)));
  return items.map(item => (shown.has(item) === isOnline(item) ? item : setOnline(item, shown.has(item))));
}
